import { workArrangmentDescription } from 'src/app/utils/workArrangement/mapper';
import type { Tealium } from 'src/types/appState';

export default (tealium: Tealium) => {
  const {
    autoClassifyCategoryChosen,
    autoClassifyCategorySuggested,
    cajaPayType,
    cajaWorkType,
    cajaWorkplaceOption,
    experiments,
    hubbleExperiments,
    jobAdClassification,
    jobAdSubClassification,
    roleTitle,
    recommendedSalaryRange,
    cajaSalaryCurrency,
    salaryRangeSelected,
  } = tealium;
  return {
    adSalaryRangeRecommended: recommendedSalaryRange,
    adSalaryRangeSelected: salaryRangeSelected,
    experiments,
    hubbleExperiments,
    jobClassification: jobAdClassification,
    jobSubClassification: jobAdSubClassification,
    jobClassificationSelectedPosition: autoClassifyCategoryChosen,
    jobClassificationSuggestedCount: autoClassifyCategorySuggested,
    jobSalaryType: cajaPayType,
    jobSalaryCurrency: cajaSalaryCurrency,
    jobWorkType: cajaWorkType,
    workplaceOption: workArrangmentDescription(cajaWorkplaceOption),
    jobTitle: roleTitle,
  };
};
